export default __webpack_public_path__ + "static/media/stripe_icon.3533eff5.svg";